module.exports = __webpack_public_path__ + "img/location-icon.99ff3b94.png";